import { connect } from 'react-redux';
import {
    fetchGetNotValidatedOrgs,
    getNotValidatedOrgsData,
    loadingOrgs,
    resetTotalElementsForNotValidated,
    startOrgValidation
} from "../../../reducers/organization/organizations";
import {getTranslation} from "../../../reducers/common/localization";
import OrgsToValidateList from "./OrgsToValidateList";
import {MODAL_REMOVE_ORG, showModal} from '../../../reducers/common/activeModal';
import {getSubRoles} from '../../../reducers/account/role';

const mapStateToProps = state => {
    return {
        loading: loadingOrgs(state),
        data: getNotValidatedOrgsData(state),
        translation: getTranslation(state),
        subRoles: getSubRoles(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(resetTotalElementsForNotValidated());
            dispatch(fetchGetNotValidatedOrgs());
        },
        onStartValidation: (id) => dispatch(startOrgValidation(id)),
        onRemoveOrg: () => dispatch(showModal({modalKey: MODAL_REMOVE_ORG}))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgsToValidateList);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgsListToValidate/OrgsToValidateList.container.js